<div class="profile-dialog" [formGroup]="profileForm">
  <!-- Header -->
  <div class="profile-dialog__header">
    <h2 class="profile-dialog__title">{{ "USER_PROFILE.TITLE" | translate }}</h2>
  </div>

  <!-- Form Fields -->
    <div class="profile-dialog__form">
      <!-- Name Field -->
      <vdo-input-text
        id="profile-name"
        vdoAutoTestId
        label="USER_PROFILE.FIELDS.PROFILE_NAME"
        formControlName="name"
        type="text"
        appearance="legacy">
      </vdo-input-text>

      <!-- Email Field -->
      <vdo-field-info
        label="USER_PROFILE.FIELDS.EMAIL"
        [value]="emailValue()">
      </vdo-field-info>
    </div>

  <!-- Actions -->
    <div class="profile-dialog__actions">
      <button vdo-btn-stroked
              id="vdo-profile-button-cancel"
              vdoAutoTestId
              type="button"
              (click)="onCancel()"
              [disabled]="isLoading()">
        {{ "USER_PROFILE.BUTTONS.BACK" | translate }}
      </button>
      <button vdo-btn-flat
              id="vdo-profile-button-save"
              vdoAutoTestId
              type="submit"
              (click)="onSave()"
              [isLoading]="isLoading()">
        {{ "USER_PROFILE.BUTTONS.SAVE" | translate }}
      </button>
    </div>
</div>
